import { stringify } from 'qs';

// eslint-disable-next-line no-restricted-imports
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';

import { FEATURES } from './features';

const territories = [
  'Atlanta, GA',
  'Boston, MA',
  'Chicago, IL',
  'Dallas - Fort Worth, TX',
  'Detroit, MI',
  'Houston, TX',
  'Los Angeles, CA',
  'Miami, FL',
  'New York, NY',
  'Philadelphia, PA',
  'Phoenix, AZ',
  'San Diego, CA',
  'San Francisco, CA',
  'Seattle, WA',
  'Washington DC'
];

const QUERY_DELIMITER = isFeatureEnabled(FEATURES.HASH_QUERY_PARAMS) ? '#' : '?';

export const POPULAR_AREAS = territories.map(name => ({
  name,
  url: `/shelters${QUERY_DELIMITER}locate=${stringify({ query: { location: name } })}`
}));
